function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgPaper = function SvgPaper(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("polygon", {
    style: {
      fill: "#CDCFCF"
    },
    points: "247.172,4.414 247.172,108.465 461.912,323.204 318.72,463.448 512,463.448 512,4.414 "
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#A6ABAB"
    },
    d: "M467.862,66.207h-52.966c-4.873,0-8.828-3.955-8.828-8.828s3.955-8.828,8.828-8.828h52.966 c4.873,0,8.828,3.955,8.828,8.828S472.735,66.207,467.862,66.207"
  }), React.createElement("path", {
    style: {
      fill: "#A6ABAB"
    },
    d: "M467.862,154.483h-52.966c-4.873,0-8.828-3.955-8.828-8.828c0-4.873,3.955-8.828,8.828-8.828h52.966 c4.873,0,8.828,3.955,8.828,8.828C476.69,150.528,472.735,154.483,467.862,154.483"
  }), React.createElement("path", {
    style: {
      fill: "#A6ABAB"
    },
    d: "M450.207,110.345h-35.31c-4.873,0-8.828-3.955-8.828-8.828s3.955-8.828,8.828-8.828h35.31 c4.873,0,8.828,3.955,8.828,8.828S455.08,110.345,450.207,110.345"
  }), React.createElement("path", {
    style: {
      fill: "#A6ABAB"
    },
    d: "M467.862,295.724h-42.258c-4.873,0-8.828-3.955-8.828-8.828c0-4.873,3.955-8.828,8.828-8.828h42.258 c4.873,0,8.828,3.955,8.828,8.828C476.69,291.769,472.735,295.724,467.862,295.724"
  }), React.createElement("path", {
    style: {
      fill: "#A6ABAB"
    },
    d: "M467.862,251.586h-86.396c-4.873,0-8.828-3.955-8.828-8.828s3.955-8.828,8.828-8.828h86.396 c4.873,0,8.828,3.955,8.828,8.828S472.735,251.586,467.862,251.586"
  }), React.createElement("path", {
    style: {
      fill: "#A6ABAB"
    },
    d: "M467.862,207.448H337.329c-4.873,0-8.828-3.955-8.828-8.828c0-4.873,3.955-8.828,8.828-8.828 h130.534c4.873,0,8.828,3.955,8.828,8.828C476.69,203.494,472.735,207.448,467.862,207.448"
  }), React.createElement("path", {
    style: {
      fill: "#A6ABAB"
    },
    d: "M467.862,384H408.85c-4.873,0-8.828-3.955-8.828-8.828c0-4.873,3.955-8.828,8.828-8.828h59.012 c4.873,0,8.828,3.955,8.828,8.828C476.69,380.045,472.735,384,467.862,384"
  }), React.createElement("path", {
    style: {
      fill: "#A6ABAB"
    },
    d: "M467.862,428.138H363.785c-4.873,0-8.828-3.955-8.828-8.828c0-4.873,3.955-8.828,8.828-8.828 h104.077c4.873,0,8.828,3.955,8.828,8.828C476.69,424.183,472.735,428.138,467.862,428.138"
  })), React.createElement("polygon", {
    style: {
      fill: "#ECF1F1"
    },
    points: "461.912,323.204 273.655,507.586 0,235.82 187.26,48.552 "
  }), React.createElement("polygon", {
    style: {
      fill: "#8697CB"
    },
    points: "268.412,204.606 156.054,316.963 68.67,229.57 181.027,117.222 "
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#B5C3E8"
    },
    d: "M187.26,198.365c10.346,10.346,10.346,27.109,0,37.455c-10.346,10.337-27.11,10.337-37.455,0 c-10.337-10.346-10.337-27.11,0-37.455C160.15,188.019,176.914,188.019,187.26,198.365"
  }), React.createElement("path", {
    style: {
      fill: "#B5C3E8"
    },
    d: "M181.645,291.363l61.166-61.166c-17.143-11.352-40.457-9.481-55.552,5.614 C172.156,250.915,170.293,274.229,181.645,291.363"
  })), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#CDCFCF"
    },
    d: "M181.018,363.246c-2.26,0-4.52-0.865-6.241-2.586c-3.452-3.452-3.452-9.031,0-12.482l62.42-62.42 c3.452-3.452,9.039-3.452,12.482,0c3.452,3.443,3.452,9.031,0,12.482l-62.42,62.42 C185.538,362.381,183.278,363.246,181.018,363.246"
  }), React.createElement("path", {
    style: {
      fill: "#CDCFCF"
    },
    d: "M268.412,275.853c-2.26,0-4.52-0.865-6.241-2.586c-3.452-3.452-3.452-9.031,0-12.482l37.455-37.455 c3.443-3.443,9.031-3.443,12.482,0c3.443,3.452,3.443,9.039,0,12.482l-37.455,37.455 C272.931,274.988,270.671,275.853,268.412,275.853"
  }), React.createElement("path", {
    style: {
      fill: "#CDCFCF"
    },
    d: "M212.233,394.452c-2.26,0-4.52-0.865-6.241-2.586c-3.452-3.452-3.452-9.031,0-12.482l124.84-124.84 c3.452-3.452,9.031-3.452,12.482,0s3.452,9.031,0,12.482l-124.84,124.84C216.753,393.587,214.493,394.452,212.233,394.452"
  }), React.createElement("path", {
    style: {
      fill: "#CDCFCF"
    },
    d: "M280.894,388.211c-2.26,0-4.52-0.865-6.241-2.586c-3.452-3.452-3.452-9.031,0-12.482l87.384-87.384 c3.452-3.452,9.039-3.452,12.482,0c3.452,3.443,3.452,9.031,0,12.482l-87.384,87.384 C285.414,387.346,283.154,388.211,280.894,388.211"
  }), React.createElement("path", {
    style: {
      fill: "#CDCFCF"
    },
    d: "M243.438,425.657c-2.26,0-4.52-0.865-6.241-2.586c-3.452-3.452-3.452-9.031,0-12.482l12.482-12.482 c3.452-3.452,9.031-3.452,12.482,0c3.452,3.452,3.452,9.031,0,12.482l-12.482,12.482 C247.958,424.792,245.698,425.657,243.438,425.657"
  }), React.createElement("path", {
    style: {
      fill: "#CDCFCF"
    },
    d: "M274.653,456.872c-2.26,0-4.52-0.865-6.241-2.586c-3.452-3.452-3.452-9.031,0-12.482l49.938-49.938 c3.443-3.443,9.031-3.443,12.482,0c3.443,3.452,3.443,9.039,0,12.482l-49.938,49.938 C279.172,456.007,276.913,456.872,274.653,456.872"
  }), React.createElement("path", {
    style: {
      fill: "#CDCFCF"
    },
    d: "M349.555,381.97c-2.26,0-4.52-0.865-6.241-2.586c-3.452-3.452-3.452-9.031,0-12.482l49.938-49.938 c3.443-3.443,9.031-3.443,12.482,0c3.443,3.452,3.443,9.039,0,12.482l-49.938,49.938 C354.074,381.105,351.815,381.97,349.555,381.97"
  })), React.createElement("polygon", {
    style: {
      fill: "#A6ABAB"
    },
    points: "291.31,48.552 291.31,152.602 293.191,154.483 379.586,154.483 379.586,48.552 "
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPaper, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/paper.6c4c9246.svg";
export { ForwardRef as ReactComponent };